import { Card } from '@driverforce/shared-ui';

export const Forbidden: React.FC = () => (
  <Card padding="lg">
    <h2 className="text-xl font-semibold text-gray-900 mb-1">Forbidden</h2>
    <p className="text-sm text-gray-600">Admin role required to view this page.</p>
  </Card>
);
